import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  public update = false;
  public chargesModel: any = {
    driverChargedEnable: false,
    driverChargeAmount: '',
    passengerChargeEnable: false,
    passengerChargeAmount: '',
  };

  constructor(public router: Router,
    public service: AmbitService) { }

  ngOnInit() {
    
this.getChargesData();
  }

  getChargesData(){
    var self = this;
    firebase.database().ref().child('Charges/')
    .once('value', function (snapshot) {
      var data = snapshot.val();
      if (data) {
        for (var key in data) {
          self.chargesModel = data[key];
          self.chargesModel.key = key
        }
      }
    });
  }

  updateCharges() {
    var self = this;
    self.chargesModel.timeStamp = firebase.database.ServerValue.TIMESTAMP;
    if(!self.chargesModel.key) {

      firebase.database().ref('Charges').push(self.chargesModel).then((result) => {
        self.getChargesData();
        alert('Charges Added!');
        self.update = false ;
      }).catch((err) => {
        alert(err);
      });
    } else {
      firebase.database().ref('users/' + self.chargesModel.key).update(self.chargesModel).then((result) => {
        alert("Charges Updated!");
        self.update = false ;
      }).catch((error) => {
        alert(error);
      });
    }

    

  }

  navigateTo(link:any) {
     this.router.navigate([link]); 
   }


}
